import React from "react";
import { Button } from "@mui/material";

export interface RevealAllButtonProps {
  revealAll: boolean;
  onToggle: () => void;
}

/**
 * Header text button that reveals or hides every tax ID in the column. Stops the click
 * from reaching the header so it never also toggles the column's sort.
 */
export function RevealAllButton({ revealAll, onToggle }: RevealAllButtonProps) {
  return (
    <Button
      size="small"
      variant="text"
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
      onKeyDown={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
      aria-pressed={revealAll}
      aria-label={revealAll ? "Hide all tax IDs" : "Show all tax IDs"}
      sx={{
        minWidth: 0,
        minHeight: 0,
        px: 1,
        py: 0,
        fontSize: "0.75rem",
        textTransform: "none",
        letterSpacing: 0,
        whiteSpace: "nowrap",
      }}
    >
      {revealAll ? "Hide all" : "Show all"}
    </Button>
  );
}

export default RevealAllButton;
